import './bridgescafe/style';
import FormStructure from './bridgescafe/form_structure';

export default FormStructure;